// extracted by mini-css-extract-plugin
module.exports = {"shippingCountdown":"ShippingCountdown_shippingCountdown__2uJ_D"};